import { render, staticRenderFns } from "./activeCenter.vue?vue&type=template&id=e5be603c&"
import script from "./activeCenter.vue?vue&type=script&lang=js&"
export * from "./activeCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports